export const PPP = 'PLANO FREE FLOW'

// Backwards-compatible CATEGORY object used across the app/tests
export const CATEGORY = {
  PPP
}
